import React from 'react'
import { Link } from 'react-router-dom'
import { PATH } from '../../../../app/routes'
import { useConnectionCreateAccess } from '../../../../features/clientUsers/useClientAccess'

const ConnectorType = () => {
    const { canCreate } = useConnectionCreateAccess()
    return canCreate ? (
        <Link to={PATH.NEW_CONNECTOR} className="btn btn-primary btn-rounded waves-effect waves-light float-right new-connector">
            + New Connector
        </Link>
    ) : null
}

export default ConnectorType
